// extracted by mini-css-extract-plugin
module.exports = {"productBrand":"ProductBrand_productBrand__um3Jd","productBrandLink":"ProductBrand_productBrandLink__MRECv"};